import { type Spec } from "@json-render/react";
import {
  isValidJsonRenderSpec,
  parseDynamicUiBody,
} from "@utils/parseDynamicUiBody";
import {
  resolveSignalCardDynamicUiSpec,
  type ResolveSignalCardDynamicUiInput,
} from "@utils/resolveSignalCardDynamicUi";

export { parseDynamicUiBody };

/** @deprecated 使用 isValidJsonRenderSpec；保留别名兼容既有引用 */
export const isValidSpec = isValidJsonRenderSpec;

export interface ParsedNotifyMessageContent {
  title: string | null;
  body: unknown;
}

export interface ResolvedNotificationBody {
  hasBody: boolean;
  bodyText: string | null;
  spec: Spec | null;
  hasInvalidBody: boolean;
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const parseNotifyMessageContent = (
  content: unknown,
): ParsedNotifyMessageContent | null => {
  if (typeof content !== "string") {
    return null;
  }
  try {
    const parsed = JSON.parse(content);
    if (isRecord(parsed)) {
      return {
        title: typeof parsed.title === "string" ? parsed.title : null,
        body: parsed.body,
      };
    }
    return {
      title: null,
      body: content,
    };
  } catch {
    return {
      title: null,
      body: content,
    };
  }
};

export const resolveNotificationBody = (
  body: unknown,
  input?: ResolveSignalCardDynamicUiInput,
): ResolvedNotificationBody => {
  if (typeof body === "string") {
    const spec = resolveSignalCardDynamicUiSpec(body, input);

    if (spec) {
      return {
        hasBody: true,
        bodyText: null,
        spec,
        hasInvalidBody: false,
      };
    }
  }

  return {
    hasBody: body != null,
    bodyText: null,
    spec: null,
    hasInvalidBody: body != null,
  };
};
